import React from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Seo, { breadcrumbSchema } from "@/components/Seo";
import { Search, CalendarCheck, Heart, ShieldCheck } from "lucide-react";

export default function HowItWorks() {
  return (
    <div className="min-h-screen bg-linen">
      <Seo
        title="How Sakeenah Circle works"
        description="Three simple steps to find a trusted, verified caregiver on Sakeenah Circle. Search, request a booking, leave a heartfelt review."
        path="/how-it-works"
        jsonLd={breadcrumbSchema([{ name: "How it works", path: "/how-it-works" }])}
      />
      <Nav />
      <section className="max-w-5xl mx-auto px-5 sm:px-8 py-16">
        <span className="badge-sage">The Sakeenah Way</span>
        <h1 className="font-serif text-5xl text-forest mt-3 leading-tight">Peace of mind, in three quiet steps.</h1>
        <div className="mt-12 space-y-8">
          {[
            { icon: Search, t: "Search with intention", d: "Filter by postal code, CPR & police-check verification, languages, availability and rating. Only sitters who match what your family needs surface." },
            { icon: CalendarCheck, t: "Request a booking", d: "Choose your dates, share notes about your children, and send a request. Your sitter responds within a couple of hours." },
            { icon: Heart, t: "Care, delivered with grace", d: "After every booking, share a heartfelt review — helping other families in the circle find their calm too." },
          ].map((s, i) => (
            <div key={i} className="card-organic p-8 flex gap-6 items-start">
              <div className="w-14 h-14 rounded-full bg-sage/25 flex items-center justify-center shrink-0"><s.icon className="w-6 h-6 text-forest" /></div>
              <div>
                <div className="font-serif text-sm text-taupe">Step {i + 1}</div>
                <h3 className="font-serif text-2xl text-forest mt-1">{s.t}</h3>
                <p className="text-forest/75 mt-2 leading-relaxed">{s.d}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="card-organic p-8 mt-12 flex items-start gap-4">
          <ShieldCheck className="w-8 h-8 text-gold shrink-0" />
          <div>
            <h3 className="font-serif text-2xl text-forest">Our verification promise</h3>
            <p className="text-forest/75 mt-2 leading-relaxed">Every sitter joining the Sakeenah Circle submits a police background check and CPR certification. Our admin team reviews each application by hand — you'll see a gold ‘Verified' seal on sitters we've cleared.</p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
